
<template>
  <div class="mainContainer" :class="{ hiddenForm: !this.show }" :id="'form'">

    <!-- BANNER -->
    <div class="banner">
      <img src="../assets/header_form_mobile_v2.png" />
    </div>

    <!-- FORM -->
    <div class="product__section" id="form">
      <!-- MOCK Uncomment line below-->
        <!-- <div v-if="!notSend">  -->
      <div v-if="notSend">
        <section class="container">
          <div class="content__data">
            <div class="header__form">
              <div class="content__data__title">
                <div class="content__data__description">
                  <!-- <h1>Você pode ganhar um cupom de desconto <br class="only-desktop" /> cadastrando seus dados abaixo </h1> -->
                  <h1>Cadastre-se e receba novidades<br class="only-desktop" /> e ofertas exclusivas da Samsung</h1>
                </div>
              </div>
            </div>
            <form class="content__data__form">
              <div class="content__data__form__side nome">
                <!-- <label for="firstName">Nome:</label> -->
                <input v-on:keydown="textValidation($event)" type="text" placeholder="Nome:" name="nome" class="input_name input_actual_name"
                  v-model="fieldsData.firstName" @change="onChangeInput" required />
                <span class="content__data__form__error" v-if="error.firstName">{{
                    error.firstName
                }}</span>
                <!-- <label for="lastName">Sobrenome:</label> -->
                <input v-on:keydown="textValidation($event)" type="text" placeholder="Sobrenome:" name="sobrenome" class="input_name"
                  v-model="fieldsData.lastName" @change="onChangeInput" required />
                <span class="content__data__form__error" v-if="error.lastName">{{
                    error.lastName
                }}</span>
              </div>
              <div class="content__data__form__side">
                <!-- <label for="firstName">E-mail:</label> -->
                <input type="email" placeholder="E-mail:" name="email" v-model="fieldsData.email" @change="onChangeInput" required />
                <span class="content__data__form__error" v-if="error.email">{{
                    error.email
                }}</span>
              </div>
              <div class="content__data__form__side nasc_check">
                <!-- <label for="firstName">Nascimento:</label> -->
                <input type="text" placeholder="Nascimento:" class="nasc__data" name="data-nascimento" v-mask="'##/##/####'"
                  v-model="fieldsData.birthday" @change="onChangeInput" required />
                <span class="content__data__form__error" v-if="error.birthday">{{
                    error.birthday
                }}</span>
                <div class="content__data__form__full">
                  <label class="content__data__form__full__checkbox">
                    Autorizo que meus dados sejam utilizados de acordo com a
                    <a href="https://www.samsung.com/br/info/privacy/" target="_blank">Política de Privacidade da
                      Samsung</a>
                    <input type="checkbox" name="aceitou-politica-privacidade" v-model="fieldsData.privacyPolicy"
                      @change="onChangeInput" required />
                    <span v-bind:class="[
                      'checkmark',
                      error.privacyPolicy && !fieldsData.privacyPolicy
                        ? 'error'
                        : '',
                    ]"></span>
                  </label>

                  <label class="content__data__form__full__checkbox">
                    Aceito receber novidades por e-mail
                    <input type="checkbox" name="aceitou-marketing" v-model="fieldsData.marketingOptIn"
                      @change="onChangeInput" />
                    <span v-bind:class="[
                      'checkmark',
                      error.marketingOptIn ? 'error' : '',
                    ]"></span>
                  </label>
                </div>
              </div>
              <div class="recp_btn">
                <div class="content__data__form__full recaptcha">
                  <span class="content__data__form__error" v-if="error.recaptcha">{{ error.recaptcha }}</span>
                  <template>

                    <!-- RECAPTCHA PROD E TST -->
                    <vue-recaptcha id="gRecaptcha" sitekey="6LdnIgYbAAAAAMJqlTMggwcuhmWlxFdSaq7j1pGj">
                    </vue-recaptcha>

                    <!-- RECAPTCHA LOCAL TESTING AND OTHER SERVERS -->
                    <!-- <vue-recaptcha id="gRecaptcha" sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI">
                    </vue-recaptcha> -->

                  </template>
                </div>
                <section class="btn__section">
                  <div class="btn_form_area">
                    <a id="btn_voltar_lista" class="link" v-on:click="backToTop">Voltar</a>
                    <a id="btn_cadastro" class="button primary" v-if="enviado == 'enviar'"
                      v-on:click="onSend">Cadastre-se</a>
                  </div>
                  <div class="btn_loading" v-if="enviado == 'loading'">
                    <div class="one"></div>
                    <div class="two"></div>
                    <div class="three"></div>
                  </div>
                  <div v-if="enviado == 'erro'">
                    <h2 class="btn_erro">Ops, algo deu errado!</h2>
                    <p class="btn_erro_p">Tente novamente mais tarde.</p>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </section>
      </div>
      <div class="send-form-area" v-else>
        <section class="form__enviado">
          <div class="cupon-informations-area">
            <div v-if="cuponInformations.Id && cuponInformations.Id !== -1">
              <h1 class="bold-text">Você ganhou {{ cuponInformations.DiscountAsString }}% de desconto <br /> </h1>
              
              
              <div class="code" @click="copyToClipboard">
                <div class="code-header">
                  <strong>Seu cupom é:</strong>
                </div>
                <div class="code-body">
                  <span>{{ cuponInformations.Code }}</span>
                  <CopyIcon />
                </div>
              </div>

              <h1 class="medium-text">Aproveite para já comprar <br class="only-mobile" />
                sua TV ideal com desconto</h1>
              <small>Cupom válido até às 23:59 de hoje</small>
            </div>

            <!-- <h1 class="normal-text" v-else>Nossos cupons de desconto acabaram por hoje, mas pode voltar amanhã e tentar
              de novo</h1> -->
              <h1 class="normal-text" v-else>Sua TV ideal está aqui<br /> </h1>
            <section style="display: flex; justify-content: center; gap: 1rem;">
              <button id="btn_voltar_lista" class="link" v-on:click="backToTop">Voltar</button>
              <button id="btn_compre_agora" class="button primary" v-on:click="handleClickBuyNow">Compre agora</button>
            </section>
          </div>

          <Soundbar :soundbar="this.soundbar" :selectedTv="this.selectedTv" @backToTop="backToTop"/>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import qs from "querystring";
import { format, parse } from "date-fns";
import { VueRecaptcha } from 'vue-recaptcha';
import Soundbar from '../components/Soundbar.vue';

import fieldValidations from "../utils/fieldValidations";
import errorMessages from "../constants/errorMessages";
// import recaptcha from "./Recaptcha.vue";

import CopyIcon from "../assets/copy.svg";

export default {
  name: "Form",
  components: { VueRecaptcha, Soundbar, CopyIcon },
  props: ["show", "selectedTv", "soundbar"],
  gtm: {
    enabled: true /* see below */,
    debug: true,

    layer: "dataLayer",
    variables: {},

    pageTracking: true,
    pageViewEventName: "nuxtRoute",

    autoInit: true,
    respectDoNotTrack: true,


    // scriptId: 'gtm-script',
    // scriptDefer: false,
    // scriptURL: 'https://www.googletagmanager.com/gtm.js',
    // crossOrigin: false,

    // noscript: true,
    // noscriptId: 'gtm-noscript',
    // noscriptURL: 'https://www.googletagmanager.com/ns.html'
  },
  data() {
    return {
      enviado: "enviar",
      notSend: true,
      cuponInformations: {
      //   // MOCK
      //  Id: -1,
      //  DiscountAsString: '25',
      //  Code: 'sastc3105-7hwysoyqqwpe2uq'
      },
      fieldsData: {
        firstName: "",
        lastName: "",
        birthday: "",
        email: "",
        phoneNumber: "",
        privacyPolicy: false,
        marketingOptIn: false,
        tv: false,
        soundBar: false,
        fridge: false,
        dryWash: false,
        vacuumCleaner: false,
        airConditioning: false,
        monitors: false,
        notebooksAndTablets: false,
        smartphonesAndWearables: false,
      },
      error: {
        firstName: false,
        lastName: false,
        birthday: false,
        email: false,
        privacyPolicy: false,
        recaptcha: false,
      },
    };
  },
  methods: {
    backToTop() {
      this.$emit("backToTop", "form");

      document.querySelector(".resources-soundbar").scrollLeft = 0;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    textValidation(e) {
      if (!e.key.match(/^[a-z A-Z]*$/)) {
        e.preventDefault();
      }
    },

    onChangeInput(e) {

      window.click_s_evar_event('o', '26', 'formulario', 'preenchimento', this.selectedTv.displayName + "-" + e.target.name);

      this.error[e.target.name] = false;
    },

    handleClickBuyNow() {
      window.open(this.selectedTv.shopUrlTagged);
    },

    copyToClipboard(){
      Vue.$toast.clear();

      navigator.clipboard.writeText(this.cuponInformations.Code);

      Vue.$toast.open({
        message: 'Cupom copiado',
        type: 'success',
        position: 'bottom'
      });
    },

    async onSend() {
      let error = null;

      // trim
      var firstName = this.fieldsData.firstName.trim();

      var lastName = this.fieldsData.lastName.trim();

      var email = this.fieldsData.email.trim();

      if (!fieldValidations["required"](firstName))
        error = this.error["firstName"] = errorMessages.REQUIRED_FIELD;
      if (!fieldValidations["required"](lastName))
        error = this.error["lastName"] = errorMessages.REQUIRED_FIELD;
      if (!fieldValidations["required"](this.fieldsData.birthday))
        error = this.error["birthday"] = errorMessages.REQUIRED_FIELD;
      if (!fieldValidations["birthday"](this.fieldsData.birthday))
        error = this.error["birthday"] = errorMessages.INVALID_BIRTHDAY;
      if (!fieldValidations["required"](email))
        error = this.error["email"] = errorMessages.REQUIRED_FIELD;
      if (!fieldValidations["email"](email))
        error = this.error["email"] = errorMessages.INVALID_EMAIL;
      if (!this.fieldsData.privacyPolicy)
        error = this.error["privacyPolicy"] =
          "É obrigatório o aceite da Política de Privacidade da Samsung.";
      if (window.grecaptcha.getResponse() === "")
        error = this.error["recaptcha"] =
          'Por favor, clique em "Não sou um robô."';

      if (!(error === null)) return;

      this.enviado = "loading";
      let responseGetCupon = {};

      try {
        // MOCK - Comment the line below
        responseGetCupon = await axios.get(`${process.env.VUE_APP_CUPOM_API}/api/cupon`);
      } catch (error) {
        // console.log(error);
      }

      if (responseGetCupon.data && responseGetCupon.data.Id !== -1) {
        Object.assign(this.cuponInformations, {          
          // MOCK
          // Id: -1,
          // DiscountAsString: '25',
          // Code: 'CODE12',
          ...responseGetCupon.data
        });
      }

      let luckyUser = true;

      if (!this.cuponInformations.Id || this.cuponInformations.Id === -1) {
        luckyUser = false;
      }

      axios
        .post(
          process.env.VUE_APP_BASE_API,
          qs.stringify({
            Nome: firstName,
            Sobrenome: lastName,
            Email: email,
            Nascimento: format(
              parse(this.fieldsData.birthday, "dd/MM/yyyy", new Date()),
              "yyyy-MM-dd"
            ),
            Telefone: this.fieldsData.phoneNumber
              .replace("(", "")
              .replace(")", "")
              .replace(" ", "")
              .replace("-", ""),
            //NOME DA CAMPANHA
            Campanha: process.env.VUE_APP_CAMPANHA,
            TV: this.selectedTv.sku,
            SoundBar: `${luckyUser ? this.cuponInformations.DiscountAsString : '0'}`,
            Fridge: `${luckyUser ? this.cuponInformations.Code : ''}`,
            DryWash: this.selectedTv.displayName,
            Concordo: this.fieldsData.privacyPolicy,
            MarketingOptIn: this.fieldsData.marketingOptIn,
            Recaptcha: window.grecaptcha.getResponse(),
            //VARIAVEL DE TESTE DE RECORD
            TestRecord: process.env.VUE_APP_TEST_RECORD,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(() => {
          this.enviado = "enviado";
          let _this = this;
          let numRandomicoUnico = new Date().getTime();
          
          // Samsung Analytics
          // window.click_s_evar_event('o', '45', 'formulario', 'meu-cupom', this.selectedTv.displayName);
          // window.click_s_evar_event('o', '26', 'carrossel', 'click', 'shop-parceiros-' + this.selectedTv.displayName);
          // window.fbq('trackCustom', 'CE_HOT');
          // window.gtag('event', 'conversion', {
          //   'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
          // });
          // window.twq('event', 'tw-o2ja6-oc3xw', {});
          
          // More Analytics
          window.dataLayer.push({
            event: "gtm.transaction",
            target: "gtm-more",
            action: "submit",
            label: "target-properties",
            value: 5000,
            noninteraction: "interaction-type",
            TransactionID: numRandomicoUnico,
            ModeloTV: this.selectedTv.displayName,
            CodigoCupom: this.cuponInformations.Id !== -1 ? this.cuponInformations.Code : '',
            Desconto: this.cuponInformations.Id !== -1 ? this.cuponInformations.DiscountAsString : '0',
          });
          setTimeout(() => {
            _this.notSend = false;
            _this.onReset();
          }, 800);
        })
        .catch((err) => {
          this.enviado = "erro";
          let _this = this;
          setTimeout(() => {
            _this.onReset();
            _this.enviado = "enviar";
            throw new Error(err);
          }, 8000);
        });
    },
    onReset() {
      this.fieldsData = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        birthday: "",
        email: "",
        privacyPolicy: false,
        marketingOptIn: false,
      };

      this.error = {
        firstName: false,
        lastName: false,
        phoneNumber: false,
        birthday: false,
        email: false,
        privacyPolicy: false,
        recaptcha: false,
      };
      window.grecaptcha.reset();
    },
    // execute the recaptcha widget
    executeRecaptcha() {
      this.$refs.recaptcha.execute()
    },
    mounted() {
      // if (!window.grecaptcha) {

      const scriptVueDemi = document.createElement("script");
      scriptVueDemi.src = `https://unpkg.com/vue-demi@0.12.1/lib/index.iife.js`;
      document.head.appendChild(scriptVueDemi);

      const scriptVueRecaptcha = document.createElement("script");
      scriptVueRecaptcha.src = `https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.min.js`;
      document.head.appendChild(scriptVueRecaptcha);

      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/main.scss";


.mainContainer {
  display: flex;
  flex-direction: column;
  width: 100%;


  /* BANNER */

  .banner {
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
    }
  }


  @media(min-width: $bp-mobile) {
    .banner {
      position: relative;

      width: 100%;
      padding-bottom: 23%;

      img {
        position: absolute;
        width: 100%;

        content: url("../assets/header_form_desk_v2.png");
      }
    }
  }
}



/* FORM - Styled Scoped */

/* IE CONFIGURAÇÕES */
@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
  .content__data__form__side {
    min-height: 35px;
  }

  .content__data__form>.btn_btn {
    z-index: 2;
    padding: 25px 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px !important;
  }

  .recaptcha {
    margin-top: 100px !important;
  }
}
</style>

<style scoped lang="scss">
.hiddenForm {
  display: none;
}

/* Form enviado */
.form__enviado {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.form__enviado h1,
.form__enviado h2 {
  max-width: 100%;
}

.form__enviado h1 {
  font-family: "SamsungOne";
  font-size: 1.5rem;
  // margin-bottom: 15px;
  margin: 16px auto 20px auto;
  line-height: 2rem;
  text-align: center;
}

.form__enviado h2 {
  font-family: "SamsungOne";
  font-weight: 600;
  line-height: 30px;
}

.code {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  border-radius: 1rem;
  text-align: center;
  background-color: #6E6A69;
  color: #FFF;
  font-size: 1.5rem;
  gap: .6rem;
  width: 85.5%;
  max-width: 573px;
  margin: 0 auto;
  cursor: pointer;
}
.cupon-informations-area, .mainContainer .banner{
  background-color: white;
  width: 100%;
}
.cupon-informations-area{
  padding: 30px 0;
}
.code .code-body{
  display: flex;
  text-align: center;
  align-items: end;
  gap: .8rem;
}

.code .code-body span{
  font-family: "SamsungOne";
  font-weight: normal;
  font-size: 1.125rem;
    
}

.form__enviado div .bold-text {
  font-family: "SamsungSharpSansBold";
  font-size: 2.5rem;
}

.form__enviado div .bold-text span span {
  font-family: "SamsungOneBold";
  font-size: 1.7rem;
}

.form__enviado div .medium-text {
  font-weight: 700;
  margin-bottom: 5px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
  padding: 0.5% 0 0 0;
}


.form__enviado .normal-text {
  max-width: 550px;
}

small {
  display: block;
  text-align: center;
  margin-bottom: 20px;

  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.8);
}

.largeButton {
  width: 147px;
  text-align: center;
}

/* Form section */
.product__section {
  /* display: flex;
  align-items: flex-start;
  justify-content: center; */

  background: white;
}

// .product__section .send-form-area {
//   display: flex;
//   justify-content: center;
//   align-items: flex-start;
// }

.container {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
}

.content__data {
  text-align: center;
}

.header__form {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  margin-bottom: 40px;
}

.content__data__title {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: 100%;
  max-width: 1000px;
}

.content__data__title>h2 {
  color: black;
  font-size: 20%;
}

.content__data__description {
  color: #3c3d42;
  font-family: "SamsungOne";
  font-weight: 400;
  margin: 0 70px;
  z-index: 1;
}

.content__data__description>h1 {
  font-family: $font-family-title;
  font-size: 1.8rem;
  line-height: 2rem;
}

.content__data__description>h3 {
  margin-top: 16px;

  font-family: $font-family-default-bold;
  font-size: 1rem;
  line-height: 1.5rem;
}

.content__data__form__side>.input_name {
  width: 35%;
  // margin-right: 1%;
}

.content__data__form {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  font-family: "SamsungOne";

  input{
    border-radius: 160px;
  }
}

.checkbox__title {
  text-align: center;
  font-size: 2rem;
  font-family: "SamsungSharpSans";
}
.code .code-header strong{
  font-size: 24px;
  font-weight: 700;
  font-family: "SamsungSharpSans";
}

.content__data__form__checkbox {
  width: 100%;
  height: 200px;
  margin: 20px 0;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: space-around;
}

.nome{
  max-width: 100%;
}

.input_actual_name{
  margin: 0 3% 0 0;
}

.content__data__form__side {
  flex: 0 1 80%;
  margin-bottom: 10px;
  text-align: left;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1040px;
  justify-content: center;
}

.content__data__form__side>label {
  width: 12%;
  font-size: 1.1rem;
}

.content__data__form__side>input {
  width: 73%;
  height: 35px;
  font-size: 1.3rem;
  padding: 0 15px;
  border: 1px solid #3c3d42;
  background: transparent;
  color: #3c3d42;
  box-shadow: 0px 0px 05px rgba(60, 61, 66, 0.4);
  box-sizing: border-box;
}

.nasc__data {
  width: 15% !important;
  max-width: 100%;
  // text-align: center;
}

.content__data__form__side.nasc_check {
  align-items: flex-start;
}

.content__data__form__full {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  // width: 65%;
  max-width: 55%;
  margin: 0 1.5%;
}

/* Customize the label (the container) */
.content__data__form__full__checkbox {
  display: block;
  width: 38%;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #3c3d42;
  text-align: left;
  font-size: 1rem;
  margin: 0 5%;
}

/* Hide the browser's default checkbox */
.content__data__form__full__checkbox>input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.content__data__form__full__checkbox>a {
  color: #3c3d42;
  text-decoration: underline;
}

/* Create a custom checkbox */
.checkmark {
  box-shadow: 0px 0px 5px rgba(60, 61, 66, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  box-sizing: border-box;
  border-radius: 5px;
}

.checkbox__list__span {
  border: solid 1px black;
}

.checkmark.error {
  border: red solid 2px;
}

/* On mouse-over, add a grey background color */
.content__data__form__full__checkbox:hover>input~.checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.content__data__form__full__checkbox>input:checked~.checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.content__data__form__full__checkbox>input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.content__data__form__full__checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.recp_btn {
  width: 73%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 974px;
}

/* RECAPCHA */
.content__data__form__full.recaptcha {
  align-items: center;
  justify-content: center;
  width: 50%;
  margin: 0 0 0 4%;
}

.content__data__form__full.form-response {
  color: #3c3d42;
  align-items: center;
  margin-top: 10px;
}

.content__data__form__error {
  color: #d02323;
  margin: 10px 5px;
  font-size: 14px;
  font-weight: bold;
}

.btn__section {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  margin: 0 0 0 5%;
}

.btn__section>.btn_btn {
  font-family: "SamsungSharpSans";
  display: inline-block;
  color: var(--btn-color, #fff);
  padding: 18px 25px;
  font-size: 1.1rem;
  font-weight: 800;
  background: #1428A0;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: 2px solid #1428A0;
  border-radius: 32px;
  flex: 0 1 22%;
  min-width: 40%;
}

.btn_form_area {
  #btn_voltar_lista {
    margin-right: 2rem; 
  }
}

.btn_form_area>button {
  width: 100px;
}

.btn_erro {
  font-size: 2rem;
  margin-top: 2vh;
}

.btn_erro {
  color: #3c3d42;
}

.btn_erro_p {
  color: #3c3d42;
  font-size: 1.3rem;
}

.btn_loading {
  display: flex;
  transform: translate(-50%, -50%);
  margin-top: 10%;
  margin-left: 23%;
}

.btn_loading div {
  margin: 10px;
  width: 25px;
  height: 25px;
  background-color: #3c3d42;
  border-radius: 50%;
  animation-duration: 0.7s;
  animation-iteration-count: infinite;
}

.one {
  animation-name: load-one;
}

@keyframes load-one {
  30% {
    transform: translateY(-50%);
  }
}

.two {
  animation-name: load-two;
}

@keyframes load-two {
  50% {
    transform: translateY(-50%);
  }
}

.three {
  animation-name: load-three;
}

@keyframes load-three {
  70% {
    transform: translateY(-50%);
  }
}

/* MOBILE */
@media (max-width: 940px) {
  .content__data__title>h2 {
    font-size: 1.5rem;
    width: 80%;
  }

  .content__data__description {
    width: 100%;
  }

  .content__data__description>h5 {
    font-size: 1rem;
    margin: 20px 0 10px;
  }

  .content__data__form__side {
    flex-flow: column nowrap;
    margin: 0;
  }

  .content__data__form__side>label {
    width: 100%;
    text-align: left;
    margin-bottom: 4px;
    margin-right: 3px;
    font-size: 1rem;
  }

  .content__data__form__side>input,
  .content__data__form__side>.input_name {
    width: 100%;
    margin-right: 1%;
    margin-bottom: 20px;
    text-align: center;
    font-size: 0.9rem;
  }

  .nasc__data {
    width: 100% !important;
  }

  .content__data__form__full {
    max-width: 100%!important;
    align-items: flex-start;
    margin: 10px 0!important;
  }

  .content__data__form__full__checkbox {
    width: 49%;
    margin-right: 2%;
    font-size: 0.8rem;
  }

  .recp_btn {
    width: 100%;
    flex-flow: column nowrap;
  }

  .content__data__form__full.recaptcha {
    margin-bottom: 10px;
  }

  .btn__section {
    padding: 30px 20px 10px 20px;
  }

  .btn__section>.btn_btn {
    font-size: 0.8rem;
    padding: 30px 20px 10px 20px;
    width: 200px;
  }

  .btn_erro {
    font-size: 1.2rem;
  }

  .btn_erro_p {
    font-size: 0.7rem;
  }

  .btn_loading {
    margin-top: 43px;
    margin-left: 115px;
  }

  .btn_loading div {
    width: 18px;
    height: 18px;
  }

  .form__enviado h1 {
    font-size: 1.5rem;
  }

  .form__enviado h2 {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {

  .code{
    font-size: 1rem !important;
    gap:0;
  }
 
  .code .code-body span{
    font-weight: bold;
  }
  .send-form-area{
    width: 100%;
  }
  
 
  .form__enviado div .bold-text{
    font-size: 1.25rem;
    width: 100%;
  }

  .only-mobile {
    display: block;
  }

  .only-desktop {
    display: none;
  }

  .medium-text {
    font-size: 1rem!important;
  }

  .code {
    flex-direction: column;
  }

  .code .code-header{
    padding: 0 0 5px;
    text-align: center;

    width: 90%;
    border-bottom: 1px solid #7A7877;
  }

  .code .code-header strong{
    font-family:"SamsungOne";
    font-size: 1rem;
    font-weight: 400;
  }

  .code .code-body{
    align-items: center;
    padding-top:5px ;
  }

  small {
    display: block;
    text-align: center;
    margin-bottom: 20px;

    font-size: 0.9rem;
  }
}

/* MOBILE */
@media (max-width: 530px) {
  .form__enviado h1 {
    // max-width: 300px;
    text-align: center;
  }

  .form__enviado div .bold-text{
    font-size: 1.25rem;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .code .code-body span{
    font-size: 1.5rem;
  }
  .content__data__title>h2 {
    font-size: 42px;
  }

  .content__data__description>h5 {
    font-size: 20px;
  }

  .content__data__form__side {
    flex: 0 1 40%;
  }

  .content__data__form>.btn_btn {
    font-size: 16px;
    padding: 10px 40px;
  }


  .btn__section {
    width: 50%;
  }

  .only-mobile {
    display: none;
  }


  .only-desktop {
    display: block;
  }
}

/* DESKTOP */

@media (min-width: 941px) and (max-width: 944px) {
  .btn__section>.btn_btn {
    font-size: 1.1rem;
    padding: 25px 25px;
    min-width: 52%;
  }
}

@media (min-width: 945px) and (max-width: 1171px) {
  .btn__section>.btn_btn {
    font-size: 1.1rem;
    padding: 25px 25px;
    min-width: 50%;
  }
}

@media (min-width: 941px) {
  .content__data__form>.btn_btn {
    font-size: 1.2rem;
    padding: 15px 60px;
  }

  .form__enviado h1 {
    font-size: 1.6rem;
  }

  .form__enviado h2 {
    font-size: 1.4rem;
  }
 
}

@media (max-width: 1000px) {
  .content__data__form__side>label {
    font-size: 0.95rem;
  }
}

@media (min-width: 1200px) {
  .content__data__form>.btn_btn {
    margin-top: 30px;
  }
}

@media (min-width: 1400px) {
  .recp_btn {
    width: 1116px;
  }

  .content__data__description>h5 {
    font-size: 1.5rem;
  }
}

@media (min-width: 2000px) {
  .content__data__description>h5 {
    font-size: 1.8rem;
  }
}
</style>
